import {
  Divider,
  Modal,
  ModalContent,
  ModalOverlay,
  UseDisclosureReturn,
} from "@chakra-ui/react";
import { ChartNotesModalBody, ChartNotesModalHeader } from "modules";
import { useChartNotes } from "modules/charts-shared/api";
import * as React from "react";
import { AsyncChartNote } from "./AsyncChartNote";
import { AsyncChartNotesModalFooter } from "./AsyncChartNotesModalFooter";

type ChartNotesModalProps = {
  title: React.ReactNode;
  encounterId: string;
  chartId: string;
  sectionId: string;
  subsectionId?: string;
  isDisabled?: boolean;
} & Pick<UseDisclosureReturn, "isOpen" | "onClose">;

function ChartNotesModal(props: ChartNotesModalProps) {
  const {
    isOpen,
    onClose,
    title,
    encounterId,
    chartId,
    sectionId,
    subsectionId,
    isDisabled,
  } = props;

  const modalBodyRef = React.useRef<HTMLDivElement>(null);

  const scrollToBottom = React.useCallback(() => {
    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTo({ top: modalBodyRef.current.scrollHeight });
    }
  }, []);

  const { data, isLoading } = useChartNotes({
    chartCode: chartId,
    encounterId,
    section: sectionId,
    subsection: subsectionId,
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        display="flex"
        flexDirection="column"
        height="500px"
        width="540px"
        maxWidth="540px"
        bg="white"
      >
        <ChartNotesModalHeader onClose={onClose} title={title} />
        <Divider />
        <ChartNotesModalBody isLoading={isLoading} ref={modalBodyRef}>
          {data?.data.map((note) => (
            <AsyncChartNote key={note.id} note={note} />
          ))}
        </ChartNotesModalBody>
        <Divider />
        <AsyncChartNotesModalFooter
          chartId={chartId}
          encounterId={encounterId}
          sectionId={sectionId}
          subsectionId={subsectionId}
          onCreateNoteSuccess={scrollToBottom}
          isDisabled={isDisabled}
        />
      </ModalContent>
    </Modal>
  );
}

export { ChartNotesModal };
